export default "__VITE_ASSET__BmEfD4kS__"